import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,1807.05882 C492.875294,1807.05882 112.941176,1427.12471 112.941176,960 C112.941176,492.875294 492.875294,112.941176 960,112.941176 C1427.12471,112.941176 1807.05882,492.875294 1807.05882,960 C1807.05882,1427.12471 1427.12471,1807.05882 960,1807.05882 M960,0 C430.644706,0 0,430.644706 0,960 C0,1489.35529 430.644706,1920 960,1920 C1489.35529,1920 1920,1489.35529 1920,960 C1920,430.644706 1489.35529,0 960,0 M975.224471,1125.22165 C905.991529,1164.07341 780.062118,1220.43106 716.815059,1158.08753 C656.843294,1099.01929 660.118588,949.259294 723.930353,831.009882 C776.222118,734.332235 860.928,684.751059 924.739765,684.751059 C934.226824,684.751059 943.149176,685.880471 951.506824,688.026353 C1012.94682,704.176941 1046.94212,782.106353 1044.68329,901.824 C1043.44094,968.233412 1046.82918,1025.72047 1054.73506,1074.51106 C1030.90447,1091.79106 1004.47624,1108.73224 975.224471,1125.22165 M1216.35388,1169.38165 C1211.04565,1166.89694 1195.12094,1156.61929 1181.11624,1117.99341 C1388.36329,935.254588 1388.13741,735.687529 1388.02447,725.635765 L1275.08329,726.991059 C1275.08329,733.767529 1273.27624,852.920471 1158.64094,981.447529 C1157.51153,958.520471 1157.05976,932.769882 1157.62447,903.856941 C1162.14212,653.692235 1035.08329,593.268706 980.193882,578.812235 C854.829176,545.833412 704.617412,629.071059 624.655059,777.249882 C546.838588,921.249882 530.462118,1133.12753 637.643294,1238.61459 C670.622118,1271.02871 720.090353,1299.37694 792.824471,1299.37694 C854.264471,1299.37694 932.193882,1279.04753 1030.56565,1223.70635 C1051.008,1212.18635 1070.32094,1200.44047 1088.50447,1188.46871 C1108.49506,1228.67576 1135.37506,1256.34635 1169.14447,1271.93224 C1234.76329,1301.97459 1313.82212,1279.61224 1392.768,1209.70165 L1317.77506,1125.22165 C1277.11624,1161.47576 1237.69976,1178.75576 1216.35388,1169.38165",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconQuizStatsCronbachsAlphaLine = /*#__PURE__*/function (_Component) {
  _inherits(IconQuizStatsCronbachsAlphaLine, _Component);

  var _super = _createSuper(IconQuizStatsCronbachsAlphaLine);

  function IconQuizStatsCronbachsAlphaLine() {
    _classCallCheck(this, IconQuizStatsCronbachsAlphaLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconQuizStatsCronbachsAlphaLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconQuizStatsCronbachsAlpha",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconQuizStatsCronbachsAlphaLine.displayName = "IconQuizStatsCronbachsAlphaLine";
  return IconQuizStatsCronbachsAlphaLine;
}(Component);

IconQuizStatsCronbachsAlphaLine.glyphName = 'quiz-stats-cronbachs-alpha';
IconQuizStatsCronbachsAlphaLine.variant = 'Line';
IconQuizStatsCronbachsAlphaLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconQuizStatsCronbachsAlphaLine;
export { IconQuizStatsCronbachsAlphaLine };